import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Select from 'react-select';
import {
  Button,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { setFromErrors } from 'src/helpers';
import { useCreateChangeSupervisorApplyMutation, useGetCurrentSupervisorQuery } from 'src/rtk/features/myTraining/myTrainingApi';
import { useLazyGetDepartmentsByInstituteQuery } from 'src/rtk/features/setup/department/departmentApi';
import { useGetOrganizationsQuery } from 'src/rtk/features/setup/organization/setupOrganizationApi';
import { useGetSupervisorsByInstituteQuery } from 'src/rtk/features/trainingRecord/trainingRecordlApi';
import * as Yup from 'yup';
import loader from '../../assets/images/loader.gif';

interface Props {
  isOpen: boolean;
  toggle: any;
  id: string;
  trainingType?: string;
  slotName?: string;
  fcpsPartOneInfoForChange: any;
}

const ChangeSupervisorModal = (props: Props) => {
  const { isOpen, toggle, id, trainingType, slotName, fcpsPartOneInfoForChange } = props;

  const initialValues: SupervisorCourseApply = {
    exam_course_id: '',
    supervisor_id: '',
    start_date: '',
    end_date: '',
    course_session: '',
    session_year: '',
    institute_name: '',
    department: '',
    training_institute_type: '',
    trainee_category: '',
    income_category: '',
    release_order: '',
    joining_letter: '',
    office_order: '',
    message: '',
  };

  const [instituteName, setInstituteName] = useState('');
  const [instituteForDeparment, setInstituteForDeparment] = useState('');

  const [selectedInstitue, setSelectedInstitute] = useState<any>('');
  const [selectedDepartment, setSelectedDepartment] = useState<any>('');
  const [selectedSupervisor, setSelectedSupervisor] = useState<any>('');
  const [selectedReason, setSelectedReason] = useState<any>('');

  const [selectedInstitueCategory, setSelectedInstituteCategory] = useState<any>('');
  const [selectedTraineeCategory, setSelectedTraineeCategory] = useState<any>('');
  const [selectedIncomeCategory, setSelectedIncomeCategory] = useState<any>('');

  const [changeInstituteOption, setChangeInstituteOption] = useState<string>('no');
  const [toDate, setToDate] = useState<Date | null>(null);

  const [createChangeSupervisorApply, { isError, isSuccess, error, isLoading }] =
    useCreateChangeSupervisorApplyMutation();

  const { data: instituteLookupData } = useGetOrganizationsQuery();

  const { data: currentSupervisors } = useGetCurrentSupervisorQuery(id);
  console.log(currentSupervisors);

  const allInstitute: SelectOption[] =
    instituteLookupData?.data?.map((institute) => ({
      value: institute.id!,
      label: institute.organization_name,
    })) || [];

  // const { data: departmentLookupData } = useGetDepartmentsByInstituteQuery(instituteForDeparment);
  const [getDepartmentsByInstitute, { data: departmentLookupData }] = useLazyGetDepartmentsByInstituteQuery();

  useEffect(() => {
    if (instituteForDeparment !== '') {
      getDepartmentsByInstitute(instituteForDeparment);
    }
  }, [instituteForDeparment]);

  const allDepartment: SelectOption[] =
    departmentLookupData?.data?.map((department: any) => ({
      value: department.department_name,
      label: department.department_name,
    })) || [];

  const { data: supervisors } =
    useGetSupervisorsByInstituteQuery(instituteName);

  const allSupervisor: SelectOption[] =
    supervisors?.data?.filter((supervisor) => supervisor?.available_slot! >= 0)
      ?.map((supervisor) => ({
        value: supervisor?.user_id!,
        label: supervisor?.full_name! + ` - ${supervisor?.bmdc} (Available ${supervisor?.available_slot} out of ${supervisor?.session_count! + supervisor?.available_slot!})`,
      })) || [];

  const sessionOptions: SelectOption[] = [
    { label: 'Select Session', value: '' },
    { label: 'January-June', value: 'January-June' },
    { label: 'July-December', value: 'July-December' },
  ];

  const allReason: SelectOption[] = [
    { label: 'Transfer', value: 'Transfer' },
    { label: 'Death', value: 'Death' },
    { label: 'Others', value: 'Others' },
  ];

  const allTrainingInstituteCategory: SelectOption[] = [
    { label: 'Sadar Hospital/District Hospital/Zila Hospital', value: 'Sadar Hospital/District Hospital/Zila Hospital' },
    { label: 'Government Medical College Hospital (under MoHFW)', value: 'Government Medical College Hospital (under MoHFW)' },
    { label: 'Public Medical University', value: 'Public Medical University' },
    { label: 'Government Postgraduate Medical Institute (under MoHFW)', value: 'Government Postgraduate Medical Institute (under MoHFW)' },
    { label: 'Government Institute/Hospital (under MoHFW)', value: 'Government Institute/Hospital (under MoHFW)' },
    { label: 'Government Institute/Hospital (under Ministry of Defence)', value: 'Government Institute/Hospital (under Ministry of Defence)' },
    { label: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)', value: 'Govermnent Institute/Hospital (under Ministry of Home Affairs)' },
    { label: 'Government Hospital (under Ministry of public Administration)', value: 'Government Hospital (under Ministry of public Administration)' },
    { label: 'Non-Government Postgraduate Medical Institute/Hospital', value: 'Non-Government Postgraduate Medical Institute/Hospital' },
    { label: 'Non-Governmnet Charitable Organization', value: 'Non-Governmnet Charitable Organization' },
    { label: 'Private Medical College Hospital', value: 'Private Medical College Hospital' },
    { label: 'Private Hospital', value: 'Private Hospital' },
    { label: 'Foreign Institute/Hospital', value: 'Foreign Institute/Hospital' },
  ];

  const allTraineeCategory: SelectOption[] = [
    { label: 'Trainees receiving allowances in government institutions', value: 'Trainees receiving allowances in government institutions' },
    { label: 'Trainees receiving allowances by private institutions', value: 'Trainees receiving allowances by private institutions' },
    { label: 'Trainees in government employment', value: 'Trainees in government employment' },
    { label: 'Trainees in private employment', value: 'Trainees in private employment' },
  ];

  const allIncomeCategory: SelectOption[] = [
    { label: 'Yes, involvement in Job/Income generating activities', value: 'Yes' },
    { label: 'No, not involvement in Job/Income generating activities', value: 'No' },
  ];

  const err: CustomError = error as CustomError;

  const {
    handleSubmit,
    getFieldProps,
    handleChange,
    touched,
    errors,
    values,
    resetForm,
    setErrors,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      supervisor_id: Yup.string().required('Select Supervisor'),
      course_session: Yup.string().required('Select Session'),
      start_date: Yup.string().required('Select Statring Date'),
      end_date: Yup.string().required('Select End Date'),
      message: selectedReason?.value === 'Others' ? Yup.string().required('Reason is Required') : Yup.string(),
      release_order: Yup.mixed().when([], {
        is: () => changeInstituteOption === 'yes',
        then: schema => schema.required('Release Order is required'),
      }),
      joining_letter: Yup.mixed().required('Joining Letter is required'),
    }),

    onSubmit: (values: any) => {
      values.exam_course_id = id;

      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        formData.append(key, values[key]);
      });
      createChangeSupervisorApply(formData);
      console.log(values);
    },
  });

  const handleFromDateChange = (event: any) => {
    const newToDate = new Date(event.target.value);
    newToDate.setDate(newToDate.getDate() + 180);
    setToDate(newToDate);
  }

  useEffect(() => {
    if (isSuccess) {
      resetForm();
      toast.success('Supervisor Changed successfully');
      toggle(false);
    }
    if (isError) {
      toast.error(err?.message || 'Something went wrong');
      setFromErrors(err.data, setErrors);
    }
  }, [isSuccess, isError]);

  const handleInstitute = (e: any) => {
    setInstituteName(e.target.value);
    setInstituteForDeparment(e.target.value);
  };

  useEffect(() => {
    console.log(selectedInstitue?.value);
    if (selectedInstitue !== '') {
      setFieldValue('institute_name', selectedInstitue?.value);
      setInstituteName(selectedInstitue?.value + `?session_name=${values.course_session}&session_year=${values.session_year}`);
      setInstituteForDeparment(selectedInstitue?.label);
    }
  }, [selectedInstitue]);

  useEffect(() => {
    console.log(selectedDepartment?.value);
    if (selectedDepartment !== '') {
      setFieldValue('department', selectedDepartment?.value);
    }
  }, [selectedDepartment]);

  useEffect(() => {
    console.log(selectedSupervisor?.value);
    if (selectedSupervisor !== '') {
      setFieldValue('supervisor_id', selectedSupervisor?.value);
    }
  }, [selectedSupervisor]);

  useEffect(() => {
    if (currentSupervisors?.data?.session_info) {
      const year = new Date(currentSupervisors?.data?.session_info.session_start_date).getFullYear().toString();
      setFieldValue('course_session', currentSupervisors?.data?.session_info?.session_name);
      setFieldValue('session_year', year);

      setFieldValue('training_institute_type', currentSupervisors?.data?.session_info?.training_institute_type);
      setFieldValue('trainee_category', currentSupervisors?.data?.session_info?.trainee_category);
      setFieldValue('income_category', currentSupervisors?.data?.session_info?.income_category);

      setSelectedInstituteCategory(allTrainingInstituteCategory?.find((option) => option.value === currentSupervisors?.data?.session_info?.training_institute_type) || '');
      setSelectedTraineeCategory(allTraineeCategory?.find((option) => option.value === currentSupervisors?.data?.session_info?.trainee_category) || '');
      setSelectedIncomeCategory(allIncomeCategory?.find((option) => option.value === currentSupervisors?.data?.session_info?.income_category) || '');
    }
  }, [currentSupervisors]);

  useEffect(() => {
    if (selectedReason !== '') {
      selectedReason?.value !== 'Others' ? setFieldValue('message', selectedReason?.value) : values.message = '';
    }
  }, [selectedReason]);

  useEffect(() => {
    if (selectedInstitueCategory !== '') {
      setFieldValue('training_institute_type', selectedInstitueCategory?.value);
    }
  }, [selectedInstitueCategory]);

  useEffect(() => {
    if (selectedTraineeCategory !== '') {
      setFieldValue('trainee_category', selectedTraineeCategory?.value);
    }
  }, [selectedTraineeCategory]);

  useEffect(() => {
    if (selectedIncomeCategory !== '') {
      setFieldValue('income_category', selectedIncomeCategory?.value);
    }
  }, [selectedIncomeCategory]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={'static'} size="lg">
      {isLoading ? (
        <div className="overlay">
          <img src={loader} alt="Loading" height={100} width={300} />
        </div>
      ) : null}
      <ModalHeader toggle={toggle}>Supervisor Change Request for {trainingType} - {slotName}</ModalHeader>

      <ModalBody>
        <Form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div>
                <h6 className="block-heading">Current Supervisor</h6>
                {currentSupervisors &&
                  <div>
                    <div><b>Name: </b>{currentSupervisors?.data?.name}</div>
                    <div><b>Designation: </b>{currentSupervisors?.data?.designation}</div>
                    <div><b>Institute: </b>{currentSupervisors?.data?.institute_name}</div>
                    <div><b>Department: </b>{currentSupervisors?.data?.department}</div>
                  </div>
                }
              </div>
              <hr />
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className='mb-3'>
                    <div className="input-group-with-label">
                      <div className="m-0">
                        <Label className="form-Label">FCPS Part-1 Passing Session</Label>
                        <Input
                          className="form-control"
                          type="text"
                          name="course_session"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          readOnly
                          value={fcpsPartOneInfoForChange?.fcps_part1_info?.fcps_part_one_passing_session}
                        />
                      </div>
                      <div className="m-0">
                        <Label className="form-Label">FCPS Part-1 Passing Year</Label>
                        <Input
                          className="form-control"
                          type="text"
                          name="course_year"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          readOnly
                          value={fcpsPartOneInfoForChange?.fcps_part1_info?.fcps_part_one_passing_year}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='mb-3'>
                    <Label className="form-label required-field">Trainee Category</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedTraineeCategory}
                      onChange={setSelectedTraineeCategory}
                      options={allTraineeCategory}
                      placeholder='Select...'
                      name="trainee_category"
                      isDisabled
                    />
                    {errors.trainee_category && touched.trainee_category ? (
                      <div className="text-danger">{errors.trainee_category as string}</div>
                    ) : null
                    }
                  </div>

                  <div>
                    <div className="input-group-with-label mb-3">
                      <div className="m-0">
                        <Label className="form-Label required-field">From Date</Label>
                        <Input
                          className="form-control"
                          type="date"
                          name="start_date"
                          onChange={(e) => {
                            handleFromDateChange(e);
                            handleChange(e);
                          }}
                          value={values.start_date = currentSupervisors?.data?.session_info?.session_start_date}
                          readOnly
                        />
                        {errors.start_date && touched.start_date ? (
                          <div className="text-danger">{errors.start_date as string}</div>
                        ) : null}
                      </div>
                      <div className="m-0">
                        <Label className="form-Label required-field">To Date</Label>
                        <Input
                          className="form-control"
                          type="date"
                          name="end_date"
                          onChange={handleChange}
                          value={values.end_date = currentSupervisors?.data?.session_info?.session_end_date}
                          readOnly
                        />
                        {errors.end_date && touched.end_date ? (
                          <div className="text-danger">{errors.end_date as string}</div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-6 mb-3'>
                      <Label className="form-label required-field">Institute Category</Label>
                      <Select
                        isClearable={true}
                        isSearchable={true}
                        value={selectedInstitueCategory}
                        onChange={setSelectedInstituteCategory}
                        options={allTrainingInstituteCategory}
                        placeholder='Select...'
                        name="training_institute_type"
                        isDisabled
                      />
                      {
                        errors.training_institute_type && touched.training_institute_type ? (
                          <div className="text-danger">{errors.training_institute_type as string}</div>
                        ) : null
                      }
                    </div>

                    <div className='col-md-6 mb-3'>
                      <Label className="form-label required-field">Income Category</Label>
                      <Select
                        isClearable={true}
                        isSearchable={true}
                        value={selectedIncomeCategory}
                        onChange={setSelectedIncomeCategory}
                        options={allIncomeCategory}
                        placeholder='Select...'
                        name="income_category"
                        isDisabled
                      />
                      {errors.income_category && touched.income_category ? (
                        <div className="text-danger">{errors.income_category as string}</div>
                      ) : null
                      }
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-md-12'>
                      <Label className="form-label">Are You Changing Your Institute? <i className="fas fa-info-circle" title="If you are changing your Institute, then select Yes."></i> &nbsp;</Label>
                      <div className='form-check form-check-inline'>
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="change_institute"
                          id="yes"
                          value="yes"
                          checked={changeInstituteOption === 'yes'}
                          onChange={() => setChangeInstituteOption('yes')}
                        />
                        <Label className="form-check-label" htmlFor="yes">Yes</Label>
                      </div>
                      <div className='form-check form-check-inline'>
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="change_institute"
                          id="no"
                          value="no"
                          checked={changeInstituteOption === 'no'}
                          onChange={() => setChangeInstituteOption('no')}
                        />
                        <Label className="form-check-label" htmlFor="no">No</Label>
                      </div>
                    </div>

                  </div>

                  <div className='row mb-3'>
                    <div className='col-md-6'>
                      <Label className="form-label required-field">
                        Joining Letter
                      </Label>
                      <input
                        name="joining_letter"
                        type="file"
                        className="form-control"
                        placeholder="Upload"
                        onChange={(e: any) => {
                          setFieldValue('joining_letter', e.target.files[0]);
                        }}
                      ></input>
                      {errors.joining_letter && touched.joining_letter ? (
                        <div className="text-danger">{errors.joining_letter as string}</div>
                      ) : null}
                    </div>
                    <div className='col-md-6'>
                      <Label className="form-label">
                        Office Order
                      </Label>
                      <input
                        name="office_order"
                        type="file"
                        className="form-control"
                        placeholder="Upload"
                        onChange={(e: any) => {
                          setFieldValue('office_order', e.target.files[0]);
                        }}
                      ></input>
                      {errors.office_order && touched.office_order ? (
                        <div className="text-danger">{errors.office_order as string}</div>
                      ) : null}
                    </div>
                    {changeInstituteOption === 'yes' && (
                      <div className='col-md-6'>
                        <Label className="form-label required-field">
                          Release Order
                        </Label>
                        <input
                          name="release_order"
                          type="file"
                          className="form-control"
                          placeholder="Upload"
                          onChange={(e: any) => {
                            setFieldValue('release_order', e.target.files[0]);
                          }}
                        ></input>
                        {errors.release_order && touched.release_order ? (
                          <div className="text-danger">{errors.release_order as string}</div>
                        ) : null}
                      </div>
                    )}
                  </div>

                  <div className='mb-3'>
                    <Label className="form-label">Institute</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedInstitue}
                      onChange={setSelectedInstitute}
                      options={allInstitute}
                      placeholder='Select Institute'
                      name="institute_name"
                    />
                  </div>

                  <div className='mb-3'>
                    <Label className="form-label">Department</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedDepartment}
                      onChange={setSelectedDepartment}
                      options={allDepartment}
                      placeholder='Select Department'
                      name="department"
                    />
                    {errors.department && touched.department ? (
                      <div className="text-danger">{errors.department as string}</div>
                    ) : null}
                  </div>

                  <div className='mb-3'>
                    <Label className="form-label required-field">Supervisor</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedSupervisor}
                      onChange={setSelectedSupervisor}
                      options={allSupervisor}
                      placeholder='Select Supervisor'
                      name="supervisor_id"
                    />
                    {errors.supervisor_id && touched.supervisor_id ? (
                      <div className="text-danger">{errors.supervisor_id as string}</div>
                    ) : null}
                  </div>

                  <div className='mb-3'>
                    <Label className="form-label">Reason</Label>
                    <Select
                      isClearable={true}
                      isSearchable={true}
                      value={selectedReason}
                      onChange={setSelectedReason}
                      options={allReason}
                      placeholder='Select Reason'
                      name="message"
                    />
                  </div>
                  {selectedReason?.value === 'Others' &&
                    <div>
                      <Label className="form-label required-field">Others</Label>
                      <Input
                        name="message"
                        type="text"
                        placeholder="Reason"
                        onChange={handleChange}
                      ></Input>
                      {errors.message && touched.message ? (
                        <div className="text-danger">{errors.message as string}</div>
                      ) : null}
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="d-grid gap-2 d-md-flex justify-content-md-center">
            <Button color="danger" onClick={toggle}>
              Close
            </Button>

            <Button color="success" type="submit">
              Submit
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ChangeSupervisorModal;
